// Project Pipeline — all figures editable here (single source of truth).
// Power figures are PRELIMINARY potential capacity under review — not confirmed or committed utility capacity.
export const PIPELINE = {
  states: [
    { state: "Georgia", acres: "2,600 acres", parcels: "4 parcels", power: "1,300 MW" },
    { state: "Alabama", acres: "3,600 acres", parcels: "7 parcels", power: "2,100 MW" },
  ],
  totals: { acres: "6,200 acres", parcels: "11 parcels", power: "3,400 MW", powerAlt: "3.4 GW" },
  powerLabel: "Preliminary potential capacity under review — not confirmed or committed utility capacity",
  disclaimer: "Figures are preliminary and subject to due diligence and utility confirmation.",
};


export const IMAGES = {
  heroTransmission: "https://images.unsplash.com/photo-1473341304170-971dccb5ac1e?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  transmission: "https://images.unsplash.com/photo-1473341304170-971dccb5ac1e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  substation: "https://images.unsplash.com/photo-1509390221805-d1c887a72a00?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  substationNight: "https://images.unsplash.com/photo-1509391111737-9b07f052f6b6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  dataCenter: "https://images.unsplash.com/photo-1680992046626-418f7e910589?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  dataCenter2: "https://images.unsplash.com/photo-1680992044138-ce4864c2b962?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  aerialLand: "https://images.unsplash.com/photo-1515259387710-51e175f9ec6d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  residential: "https://images.unsplash.com/photo-1597026405082-eda9beae7513?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  greenhouse: "https://images.unsplash.com/photo-1524486361537-8ad15938e1a3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  warehouse: "https://images.unsplash.com/photo-1565610222536-ef125c59da2e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
};

export const NAV = [
  { label: "Projects", to: "/projects" },
  { label: "Data Centers", to: "/data-centers" },
  { label: "Partnership Support", short: "Partnerships+", to: "/data-centers#partnership-support" },
  { label: "Residential", to: "/residential" },
  { label: "Community", to: "/community" },
  { label: "Partners", to: "/partners" },
  { label: "Data Room", to: "/data-room" },
  { label: "About", to: "/about" },
  { label: "Contact", to: "/contact" },
];

export const SERVICES = [
  { icon: "Server", title: "Data Center Development", to: "/data-centers",
    body: "Site identification, land control, utility coordination, power strategy and development support for hyperscale and large-load data center projects." },
  { icon: "MapPin", title: "Land & Site Acquisition", to: "/site-submission",
    body: "Identifying and controlling strategic development sites before they become obvious to the broader market." },
  { icon: "Zap", title: "Power & Utility Infrastructure", to: "/data-centers",
    body: "Evaluation of substations, transmission, natural gas, water, wastewater and fiber required for large-scale development." },
  { icon: "Home", title: "Residential & Workforce Housing", to: "/residential",
    body: "Entitled residential projects designed to support growing communities and new employment centers." },
  { icon: "Factory", title: "Industrial Redevelopment", to: "/projects",
    body: "Repositioning former industrial properties with existing utility and infrastructure advantages." },
  { icon: "Sprout", title: "Agri-Tech & Sustainable Development", to: "/projects",
    body: "Integrating technology, agriculture, heat reuse and resource-efficient infrastructure into larger development campuses." },
];

export const PROJECT_STATUSES = [
  "Early Stage", "Site Controlled", "Entitled", "Utility Diligence",
  "Capital Formation", "Marketed", "Under NDA", "Under Development",
];

export const PROJECT_CATEGORIES = ["Data Centers", "Residential", "Industrial", "Agri-Tech", "Mixed Use"];

export const LEAD_STATUSES = ["New", "Contacted", "Qualified", "NDA", "Diligence", "Active", "Follow-Up", "Closed", "Not a Fit"];

export const PARTNER_CATEGORIES = [
  "Data Center Operators", "Developers", "Investors", "Utilities", "Builders",
  "Landowners", "Brokers", "Economic Development Authorities", "General Contractors", "Infrastructure Providers",
];

export const CONTACT_INQUIRIES = [
  "General Inquiry", "Land Submission", "Data Center Development", "Investment",
  "Utility / Infrastructure", "Builder / BTR", "Contractor", "Government / Economic Development", "Media",
];

export const DC_SECTIONS = [
  { title: "Land", body: "Assembling and controlling large, contiguous acreage with the physical characteristics required for high-density development." },
  { title: "Power", body: "Proximity to transmission, substation capacity, service territory and realistic delivery timelines for large loads." },
  { title: "Natural Gas", body: "Availability for backup generation, resiliency and industrial process requirements." },
  { title: "Water", body: "Sourcing, capacity and permitting for cooling and community demand." },
  { title: "Wastewater", body: "Treatment and discharge capacity, plus modernization opportunities." },
  { title: "Fiber", body: "Backbone access, redundant routing and connectivity to major network corridors." },
  { title: "Entitlements", body: "Zoning, rezoning, permitting and the approvals required to advance a site." },
  { title: "Community Engagement", body: "Early, transparent coordination with local stakeholders and officials." },
  { title: "Site Control", body: "Securing options and control positions before sites become widely marketed." },
  { title: "Development Partnerships", body: "Structuring relationships with operators, capital and infrastructure partners." },
];

export const POWER_INTEL = [
  "Substations", "Transmission corridors", "Utility service territory", "Existing industrial load",
  "Expansion capability", "Power delivery pathways", "Natural gas backup opportunities",
];

export const SCREENING_TOOLS = [
  { title: "Parcel Screening", desc: "Rapid parcel-level evaluation of development potential." },
  { title: "Power Screening", desc: "Proximity to transmission, substations and available capacity." },
  { title: "Data Center Site Screening", desc: "Suitability scoring for large-load technology development." },
  { title: "Utility Assessment", desc: "Water, wastewater, gas and fiber availability review." },
  { title: "LandSignal by ParcelIQ", desc: "Advanced parcel intelligence (integration coming soon)." },
  { title: "Power Optimizer", desc: "Model MW capacity, cooling and heat-reuse potential (integration coming soon)." },
];

export function statusColor(status) {
  const map = {
    "New": "bg-blue-500/15 text-blue-300 border-blue-500/30",
    "Early Stage": "bg-slate-500/15 text-slate-300 border-slate-500/30",
    "Site Controlled": "bg-amber-500/15 text-amber-300 border-amber-500/30",
    "Entitled": "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
    "Utility Diligence": "bg-blue-500/15 text-blue-300 border-blue-500/30",
    "Capital Formation": "bg-purple-500/15 text-purple-300 border-purple-500/30",
    "Marketed": "bg-cyan-500/15 text-cyan-300 border-cyan-500/30",
    "Under NDA": "bg-red-500/15 text-red-300 border-red-500/30",
    "Under Development": "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
  };
  return map[status] || "bg-slate-500/15 text-slate-300 border-slate-500/30";
}
